import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft, Play, Clock, Award } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

export default function Training() {
  const nav = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [selected, setSelected] = useState(null);
  const [level, setLevel] = useState("beginner");
  const [duration, setDuration] = useState(10);

  useEffect(() => {
    api.get("/programs").then((r) => setPrograms(r.data));
  }, []);

  const start = async () => {
    if (!selected) return;
    await api.post("/posture-session", { program: selected.key, level, duration_min: duration });
    toast.success(`+${duration * 5} posture points!`);
    setTimeout(() => nav("/home"), 600);
  };

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-10">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="training-back">
          <ChevronLeft size={16} /> Back
        </button>
        <h1 className="ps-heading text-3xl font-bold mt-4">Posture Training</h1>
        <p className="text-slate-400 text-sm">Guided posture programs. 5–20 minute sessions.</p>

        <div className="mt-6 space-y-3">
          {programs.map((p) => (
            <button
              key={p.id}
              data-testid={`program-${p.key}`}
              onClick={() => setSelected(p)}
              className={`w-full text-left ps-card p-5 transition-colors ${selected?.id === p.id ? "border-[#2fbf71]" : ""}`}
            >
              <div className="flex justify-between items-start">
                <div>
                  <div className="ps-heading font-semibold">{p.name}</div>
                  <div className="text-sm text-slate-400 mt-1">{p.description}</div>
                </div>
                <div className="text-[#2fbf71]"><Play size={20} /></div>
              </div>
            </button>
          ))}
        </div>

        {selected && (
          <div className="mt-6 ps-card p-5 ps-fade-up">
            <div className="ps-heading font-semibold mb-3">{selected.name}</div>
            <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-2">Level</div>
            <div className="flex gap-2 mb-4">
              {selected.levels.map((lv) => (
                <button
                  key={lv}
                  data-testid={`level-${lv}`}
                  onClick={() => setLevel(lv)}
                  className={`px-4 py-2 rounded-full text-sm border ${level === lv ? "bg-[#2fbf71] text-[#0a1822] border-transparent" : "border-[#1a2f40] text-slate-300"}`}
                >{lv}</button>
              ))}
            </div>
            <div className="text-xs uppercase tracking-widest text-slate-400 font-bold mb-2">Duration</div>
            <div className="flex gap-2 mb-4">
              {selected.duration_options.map((d) => (
                <button
                  key={d}
                  data-testid={`duration-${d}`}
                  onClick={() => setDuration(d)}
                  className={`flex-1 py-3 rounded-xl border text-sm font-semibold ${duration === d ? "bg-[#142534] border-[#2fbf71]" : "border-[#1a2f40] text-slate-400"}`}
                >
                  <Clock size={14} className="inline mr-1" /> {d} min
                </button>
              ))}
            </div>
            <button data-testid="start-posture-session" onClick={start} className="ps-button-primary w-full inline-flex items-center justify-center gap-2">
              <Award size={18} /> Complete Session · +{duration * 5} PTS
            </button>
          </div>
        )}
      </div>
    </PhoneFrame>
  );
}
